import { createSelector } from '@reduxjs/toolkit';
import { RootStateType } from 'App/ReduxProvider/store';

export const getBankAccount = createSelector(
  (state: RootStateType) => state.bankAccount,
  (bankAccount) => bankAccount,
);
